import { usePlatform } from "@platform/PlatformContext";

export function usePlatformClosed() {
  const { isPlatformClosed } = usePlatform();

  return isPlatformClosed ?? false;
}

export default usePlatformClosed;
